module.exports = __webpack_public_path__ + "img/reservations-followed.36d18ff9.svg";